module.exports = __webpack_public_path__ + "assets/img/logo_mobile.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/svg/logo_mobile.svg
// module id = 1984
// module chunks = 0